// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Invoice_MonthlyUsageInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /invoice/invoice/monthly_usage
 *
 * Returns monthly invoice count and limit for a franchise.
 */
import { registerContract } from './validate'

export interface Invoice_MonthlyUsageInput {
franchise_id?: number
year?: number
month?: number
}

registerContract('Invoice_MonthlyUsageInput', {
  franchise_id: { type: 'number',  required: false },
  year:         { type: 'number',  required: false },
  month:        { type: 'number',  required: false },
})
